import fp from "lodash/fp";

export const onlyStrings = fp.filter(fp.isString);

export const joinStringsWithComma = fp.compose(fp.join(", "), onlyStrings);

export const replaceLinebreak = (str, replaceWith = " ") =>
  str.replace(/(?:\r\n|\r|\n)/g, replaceWith);
